import React from 'react';
import "swiper/css/autoplay";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Autoplay, Navigation, Pagination } from "swiper";
import "./Testimonial.css";

SwiperCore.use([Navigation, Autoplay, Pagination]);

function Testimonial() {
    const testimonialSlider = {
        loop: true,
        slidesPerView: 3,
        spaceBetween: 30,
        speed: 1000,
        autoplay: {
            delay: 4000,
            disableOnInteraction: false,
        },
        navigation: {
            nextEl: '.testi-next',
            prevEl: '.testi-prev',
        },
        pagination: {
            clickable: true,
            el: '.testimonial-pagination',
        },
        breakpoints: {
            320: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1200: { slidesPerView: 3 }
        }
    };

    const reviews = [
        {
            id: 1,
            name: "Raju Joshi",
            text: "Working with this team was an absolute pleasure. Their dedication to excellence and attention to detail helped us achieve our goals seamlessly. Highly recommend their services!",
            stars: 5
        },
        {
            id: 2,
            name: "Josh Hirani",
            text: "Their innovative approach and professional service have made a significant impact on our projects. We value their partnership and look forward to continued collaboration.",
            stars: 5
        },
        {
            id: 3,
            name: "Anand Karki",
            text: "An excellent experience from start to finish. The team's expertise and support were invaluable, helping us to achieve outstanding results through creative workflow.",
            stars: 5
        },
        {
            id: 4,
            name: "Rajan Devkota",
            text: "Their dedication and professional service have been impressive. They exceeded our expectations and delivered outstanding results for our digital presence.",
            stars: 5
        }
    ];

    return (
        <section className="testimonial-area-premium">
            <div className="container">
                <div className="title-wrap">
                    <div className="sec-title">
                        <span>Success Stories</span>
                        <h2>Trusted by Creators</h2>
                        <p>Join hundreds of successful digital pioneers who have transformed their creative vision into reality with our expert guidance.</p>
                    </div>
                </div>

                <Swiper {...testimonialSlider} className="testimonial-slider-premium">
                    {reviews.map((review) => (
                        <SwiperSlide key={review.id}>
                            <div className="review-card-modern">
                                <div className="card-quote-icon">
                                    <i className="fas fa-quote-left" />
                                </div>
                                <div className="review-content">
                                    <p>"{review.text}"</p>
                                </div>
                                <div className="reviewer-meta">
                                    <div className="reviewer-info">
                                        <h5>{review.name}</h5>
                                        <div className="rating-stars">
                                            {[...Array(review.stars)].map((_, i) => (
                                                <i key={i} className="fas fa-star" />
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>

                <div className="testimonial-nav">
                    <div className="nav-btn testi-prev">
                        <i className="fas fa-chevron-left" />
                    </div>
                    <div className="nav-btn testi-next">
                        <i className="fas fa-chevron-right" />
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Testimonial;
